import 'styleguide/styleguide-critical/critical-affiliate-single';

import $ from 'jquery';

window.$ = $;
window.jQuery = $;

$(document).ready(() => {

  function parseRtn(rtn){
    return JSON && JSON.parse(rtn) || $.parseJSON(rtn);
  }

  $.ajax({
    type: 'GET',
    url: `/r/ajax/GetProductData.jsp${location.search}&largeImg=true`,
    success: function (data) {
      const products = {};
      const result = parseRtn(data)
      let templateHtml;
      const touchDevice = ('ontouchstart' in document.documentElement);
      templateHtml = $('#template-product-item-single').html();
      let listProducts = "";
      $.each(result, function (key, value) {
        const code = key;
        products[code] = value;
        const product = products[code];
        listProducts += templateHtml
            .replace(/{{name}}/g, product.name)
            .replace(/{{brand}}/g, product.brand)
            .replace(/{{price}}/g, product.price)
            .replace(/{{imgPlp}}/g, product.imgPlp);
      })
      $('#js-affiliate-widget-single').html(listProducts);
    }
  });
});


// WEBPACK FOOTER //
// ./src/scripts/entry-points/styleguide-critical/affiliate-single.js